import * as extendActionType from '../extendActionType';

export const ADMIN_GET_DOCTORS_LIST = 'doctor/ADMIN_GET_DOCTORS_LIST';
export const ADMIN_COUNT_DOCTORS = 'doctor/ADMIN_COUNT_DOCTORS';
export const CHANGE_DOCTOR_STATUS = 'doctor/CHANGE_DOCTOR_STATUS';

export const GET_DOCTOR_LIST = 'doctor/GET_DOCTOR_LIST';
export const CHANGE_DOCTOR_FILTER = 'doctor/CHANGE_DOCTOR_FILTER';
export const GET_DOCTORS_FOR_DROPDOWN = 'doctor/GET_DOCTORS_FOR_DROPDOWN';
export const CHECK_DOCTOR_FIELDS_FILLED_FOR_ERX = 'doctor/CHECK_DOCTOR_FIELDS_FILLED_FOR_ERX';
export const GET_ENCOUNTERS_CREATORS = 'doctor/GET_ENCOUNTER_CREATORS';

export const CHOOSE_DOCTOR = 'doctor/CHOOSE_DOCTOR';
export const ADMIN_CHOOSE_DOCTOR = 'doctor/ADMIN_CHOOSE_DOCTOR';

export const UPLOAD_SIGN = 'doctor/UPLOAD_SIGN';

export function checkDoctorProfileFieldsFilled(doctorId) {
    const params = doctorId && doctorId.length ? {doctorId} : {};

    return {
        type: CHECK_DOCTOR_FIELDS_FILLED_FOR_ERX,
        httpRequest: {
            path: '/doctors/check/erx',
            method: 'get',
            params,
        },
    };
}

export function adminChooseDoctor(patientId, doctorId) {
    return {
        type: ADMIN_CHOOSE_DOCTOR,
        httpRequest: {
            path: '/doctors/choose/admin',
            method: 'post',
            data: {
                doctorId,
                patientId,
            },
        },
    };
}

export function getEncountersCreators(patientId) {
    return {
        type: GET_ENCOUNTERS_CREATORS,
        httpRequest: {
            path: '/doctors/encounter/creators',
            method: 'get',
            params: {
                patientId,
            },
        },
    };
}

export function getDoctorsListForAdmin(filter) {
    return {
        type: ADMIN_GET_DOCTORS_LIST,
        httpRequest: {
            method: 'get',
            path: '/doctors',
            params: {filter},
        },
    };
}

export function getDoctorsForDropdown(search) {
    return {
        type: GET_DOCTORS_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: '/doctors/dropdown',
            params: {
                search,
            },
        },
    };
}

export function uploadSign(sign) {
    return {
        type: UPLOAD_SIGN,
        httpRequest: {
            method: 'put',
            path: '/doctors/sign',
            files: {
                sign,
            },
        },
    };
}

export function countDoctors(filter) {
    return {
        type: ADMIN_COUNT_DOCTORS,
        httpRequest: {
            method: 'get',
            path: '/doctors/count',
            params: {filter},
        },
    };
}


export function changeDoctorStatus(doctorId, data) {
    return {
        type: CHANGE_DOCTOR_STATUS,
        httpRequest: {
            method: 'post',
            path: `/doctors/${doctorId}`,
            data,
        },
    };
}

export function getDoctorList(_, {
    offset, limit, filter, order,
}) {
    return {
        type: GET_DOCTOR_LIST,
        httpRequest: {
            method: 'post',
            path: '/doctors/list',
            data: {
                offset,
                limit,
                filter,
                order,
            },
        },
        offset,
        limit,
    };
}

export function changeDoctorFilter(filter) {
    return {
        type: CHANGE_DOCTOR_FILTER,
        filter,
    };
}

export function chooseDoctor(doctorId, review, rating) {
    return {
        type: CHOOSE_DOCTOR,
        httpRequest: {
            method: 'post',
            path: '/doctors/choose',
            data: {
                doctorId,
                review,
                rating,
            },
        },
    };
}


export function clearChooseDoctorError() {
    return {
        type: extendActionType.clean(CHOOSE_DOCTOR),
    };
}



// WEBPACK FOOTER //
// ./src/reducers/doctor/doctorActions.js